// src/pages/BlogPostDetail.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import client from '../components/sanityClient';
import BlockContent from '@sanity/block-content-to-react';
import { Helmet } from 'react-helmet-async';

const BlogPostDetail = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const query = `*[_type == "post" && slug.current == $slug][0]{
      title,
      publishedAt,
      image,
      body
    }`;

    client.fetch(query, { slug })
      .then((data) => setPost(data))
      .catch((err) => setError(err));
  }, [slug]);

  if (error) return <div>Error loading post.</div>;
  if (!post) return <div>Loading...</div>;

  const { title, publishedAt, image, body } = post;
  const formattedDate = new Date(publishedAt).toLocaleDateString();

  return (
    <article style={{ maxWidth: '800px', margin: '2rem auto', padding: '1rem' }}>
        <Helmet>
        <title>{title} | Crow Spores</title>
        <meta
          name="description"
          content={`Read the full post titled "${title}" published on ${formattedDate}.`}
        />
      </Helmet>
      <h1 style={{ fontSize: '2.5rem', color: '#333' }}>{title}</h1>
      <p style={{ color: '#777' }}>{formattedDate}</p>
      {image && image.asset && image.asset.url && (
        <img
          src={image.asset.url}
          alt={title}
          style={{ width: '100%', borderRadius: '8px', margin: '1rem 0' }}
        />
      )}
      <div style={{ lineHeight: '1.8', color: '#444' }}>
        <BlockContent blocks={body} />
      </div>
    </article>
  );
};

export default BlogPostDetail;
